import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, Inject, OnDestroy, OnInit, Renderer2, signal, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonDirective } from '@coreui/angular-pro';
import { AuthService } from 'auth';
import ResizeSensor from "css-element-queries";
import { I18nService } from 'i18n';
import { ConsentComponent, Logger } from 'shared';
import { ENVIRONMENT } from '../../../../../shared/src/tokens/config.token';
import { BootstrapService } from '../../../services/bootstrap.service';
import { RouteService } from '../../../services/route.service';
import { UserService } from '../../../services/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'tos-page',
  templateUrl: './tos-page.component.html',
  styleUrl: '/tos-page.component.scss',
  imports: [ ConsentComponent, ButtonDirective ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TosPageComponent implements OnInit, OnDestroy {
  
  @ViewChild('actions') actions!: ElementRef;
  content$ = signal<string>('');
  private sensor: ResizeSensor.ResizeSensor | undefined;
  protected logger = new Logger('TosPageComponent');

  constructor(
    private router: Router, 
    private routeService: RouteService,
    private userService: UserService,
    private bootstrapService: BootstrapService,
    private authService: AuthService,
    private i18nService: I18nService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private httpClient: HttpClient,
    private destroyRef: DestroyRef,
    @Inject(ENVIRONMENT) private environment: any) {}


  ngOnInit(): void {
    this.sensor = new ResizeSensor.ResizeSensor(
      this.elementRef?.nativeElement,
      (size: {width: number, height: number}) => {
        if (size?.width < 600) {
          this.renderer.addClass(this.actions.nativeElement, 'dense');
        } else {
          this.renderer.removeClass(this.actions.nativeElement, 'dense');
        }
      }
    );
    const baseUrl = (url: string) => {
      try {
        const urlObj = new URL(url);
        return `${urlObj.protocol}/${urlObj.host}`;
      } catch (e) {
        this.logger.error('Invalid URL:', url);
        return null;
      }
    }
    const url = baseUrl(this.environment.serverUrl)
    if (url) {
      this.httpClient
          .get(`/media/${this.i18nService.getLanguage()}/policy/terms_and_conditions`, {
            responseType: 'text' as 'text',
            params: { embed: 'true' }
          })
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(tos => {
            this.logger.debug(tos);
            this.content$.set(tos || '');
          });

    }
  }

  ngOnDestroy(): void {
    this.sensor?.detach();
  }

  onAccept() {
    this.userService.setConsent('tos')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          this.logger.debug('onAccept. Consent accepted', response);
          this.bootstrapService
              .bootstrap()
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe();
        },
        error: (err) => {
          this.logger.error('onAccept. Failed to accept consent', err);
        }
      });
  }

  onDecline() {
    this.authService.logout();
  }
}